/*
The datasets details page.
*/

<template>
  <dataset-details-base />
</template>

<script>
import DatasetDetailsBase from '@/components/piveau-ui-core/EDP2-datasetDetails';

export default {
  name: 'Datasets',
  components: {
    DatasetDetailsBase,
  }
}
</script>

<style scoped lang="scss">
  @import '~@/styles/bootstrap_theme.scss';
</style>
